// import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil} from '@fortawesome/free-solid-svg-icons';
import {useState} from 'react';
import { connect } from 'react-redux';
import { createUpdateTracking,readTracking} from '../../redux/actions/Tracking/TrackingAction';
function UpdateStatus({createUpdateTracking,tracking,currTrackings}) {
    const[status,setstatus]=useState(tracking.status);
    const handleChange=()=>{
        const id=tracking.trackingId;
        const data=currTrackings.filter((track)=>track.trackingId==tracking.trackingId);
        data[0].status=status;
        console.log('uid',id);
        console.log('udata',data[0]);
        createUpdateTracking(id,data[0]);
    };
    return (
        <div>
            <select onChange={(e) => setstatus(e.target.value)} value={status} placeholder='status'>
                <option>{status}</option>
                <option value="Delivered"> Delivered</option>
                <option value="Delivered"> Delivered</option>
                <option value="Cancel Order"> Cancel Order</option>
            </select>
            <button onClick={handleChange}><FontAwesomeIcon icon={faPencil} /></button>
        </div>
    );
}

const mapStateToProps = (state) => ({
    currTrackings: state.trackings,
});
const mapDispatchToProps={
    createUpdateTracking,
    readTracking
};

export default connect(mapStateToProps,mapDispatchToProps)(UpdateStatus);
